'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var spaces = require('../../../constants/spaces.js');
var Space_module = require('../styles/Space.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Set components spacing
 *
 * @component
 * @example
 * ```jsx
 * <Space size="m">
 *   <span>content</span>
 *   <span>content</span>
 *   <span>content</span>
 * </Space>
 * ```
 */
const Space = React__namespace.forwardRef((props, ref) => {
    const { direction, size, align, justify, wrap, inline, className, children, style, ...restProps } = props;
    const cx = reactUtils.useStyles(Space_module.default);
    const classNames = cx(className, 'container', {
        [`direction-${direction}`]: direction,
        [`align-${align}`]: align,
        [`justify-${justify}`]: justify,
        wrap,
        inline,
    });
    const elementStyles = { ...style };
    const sizes = React__namespace.useMemo(() => {
        if (!size)
            return;
        const results = [0, 0];
        const normalizedSize = Array.isArray(size) ? size : [size, size];
        normalizedSize.forEach((g, index) => {
            results[index] = g || 0;
        });
        return results;
    }, [size]);
    if (sizes) {
        // eslint-disable-next-line prefer-destructuring
        elementStyles.columnGap = sizes[0];
        // eslint-disable-next-line prefer-destructuring
        elementStyles.rowGap = sizes[1];
    }
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "Space", className: classNames, style: elementStyles, ...restProps }, children));
});
Space.defaultProps = {
    direction: 'row',
    size: spaces.SPACE_SIZES.S0,
    wrap: false,
};

exports.Space = Space;
//# sourceMappingURL=Space.js.map
